import { Warning24Regular, Warning28Regular } from '@fluentui/react-icons';
import { IconProps } from '@/Components/Icons/Icons';

export const Warning = ({ className }: IconProps): JSX.Element => <Warning24Regular className={className} />;

export const WarningLarge = ({ className }: IconProps): JSX.Element => <Warning28Regular className={className} />;
